import { lazy } from 'react';
import type { LoaderFunctionArgs } from 'react-router-dom';
import { AppUrls } from '../../../urls.tsx';
import Redirector from './Redirector.tsx';

const MissedEvents = lazy(() => import('./MissedEvents.tsx'));
const MyMissedEvents = lazy(() => import('./MyMissedEvents.tsx'));
const FeedbacksApp = lazy(() => import('./FeedbacksApp.tsx'));
const FeedbacksList = lazy(() => import('./FeedbacksList.tsx'));
const WithoutFeedback = lazy(() => import('./WithoutFeedback.tsx'));
const CorrectPartnerForm = lazy(() => import('./CorrectPartnerForm.tsx'));


const FeedbackUrls = [
    {
        index: true,
        element: <FeedbacksApp />
    },
    {
        path: AppUrls.Feedbacks.Formal,
        element: <FeedbacksList notification_type={"1"} />
    },
    {
        path: AppUrls.Feedbacks.Informal,
        element: <FeedbacksList notification_type={"2"} />
    },
    {
        path: AppUrls.Feedbacks.Flash,
        element: <FeedbacksList notification_type={"3"} />
    },
    {
        path: "missedevents",
        element: <MissedEvents />
    },
    {
        path: "missedevents/mine",
        element: <MyMissedEvents />
    },
    {
        path: ":notification_id/new",
        element: <CorrectPartnerForm />
    },
    {
        path: "detail/:notification_id",
        lazy: async () => {
            const { FeedbacksListNotification } = await import('./FeedbacksListNotification.tsx');
            return { Component: FeedbacksListNotification }
        },
        loader: async ({ params }: LoaderFunctionArgs) => {
            return fetch(`/api/feedbacks/feedback-total/?notification_id=${params.notification_id}`, { credentials: "include" });
        },
    },
    {
        path: ":notification_id",
        children: [
            {
                index: true,
                element: <Redirector to={(context) => {
                    return `./${context.user.partner_abbr}`;
                }} />,
            },
            {
                path: ":partner_abbr",
                lazy: async () => {
                    const { FeedbackForm } = await import('./FeedbackForm.tsx');
                    return { Component: FeedbackForm }
                },
                loader: async ({ params }: LoaderFunctionArgs) => {
                    return fetch(`/api/feedbacks/feedback-total/?partner=${params.partner_abbr}&notification_id=${params.notification_id}`, { credentials: "include" });
                }
            }
        ]
    },
    {
        path: "partner/",
        children: [
            {
                index: true,
                element: <Redirector to={(context) => {
                    return makePartnerSentRoute(context.user.partner_abbr);
                }} />,
            },
            {
                path: ":partner_abbr",
                lazy: async () => {
                    const { FeedbacksListNotification } = await import('./FeedbacksListNotification.tsx');
                    return { Component: FeedbacksListNotification }
                },
                loader: async ({ params }: LoaderFunctionArgs) => {
                    return fetch(`/api/feedbacks/feedback-total/?partner=${params.partner_abbr}`, { credentials: "include" });
                }
            },

        ]
    },
    {
        path: "partner/due/",
        children: [
            {
                index: true,
                element: <Redirector to={(context) => {
                    return makePartnerDueRoute(context.user.partner_abbr);
                }} />,
            },
            {
                path: ":partner_abbr",
                element: <WithoutFeedback />
            }
        ]
    }

];
const makeFeedbackListRoute = (notification_type: string) => {
    switch (notification_type) {
        case "1":
            return `/feedbacks/${AppUrls.Feedbacks.Formal}`;
        case "2":
            return `/feedbacks/${AppUrls.Feedbacks.Informal}`;
        case "3":
            return `/feedbacks/${AppUrls.Feedbacks.Flash}`;
        default:
            return `/feedbacks/${AppUrls.Feedbacks.Formal}`;
    }
}
const makeFeedbackDetailRoute = (notification_id: string, partner_abbr?: string) => {
    if (partner_abbr) {
        return `/feedbacks/${notification_id}/${partner_abbr}`
    } else {
        return `/feedbacks/${notification_id}`
    }
}

const makePartnerSentRoute = (partner_abbr: string) => {
    return `/feedbacks/partner/${partner_abbr}`
}

const makePartnerDueRoute = (partner_abbr: string) => {
    return `/feedbacks/partner/due/${partner_abbr}`
}

export default FeedbackUrls;
export { makeFeedbackDetailRoute, makePartnerSentRoute, makePartnerDueRoute, makeFeedbackListRoute };